import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  createStoreProductAsync,
  updateStoreProductAsync,
  getAllStoreProductsAsync,
  getStoreProductByIdAsync,
  updateStoreProductStatusAsync,
  getCoursePackagesAsync,
  goalWiseCoursePackagesAsync,
  spokenEnglishPackagesAsync,
  deleteStoreProductAsync,
  updateStoreInventoryAsync,
  decreaseStoreInventoryAsync,
  getAllStoreOrdersAsync,
  storeOrderDetailsAsync,
  updateOrderStatusAsync,
} from "./storeProduct.async";

const initialState = {
  storeProductLoader: false,
  createStoreProduct: [],
  getAllStoreProduct: [],
  updateStoreProd: [],
  getStoreProdByIdData: [],
  storePackageStatus: [],
  packageActivation: [],
  allPackages: [],
  packageByGoal: [],
  spokenEnglishPacks: [],
  deleteStorePackage: [],
  updateStoreInventory: [],
  decreaseStoreInventory: [],
  getAllOrders: [],
  getAllOrderById: [],
  updateStatus: [],
};

export const storeProductSlice = createSlice({
  name: "StoreProduct",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getCoursePackagesAsync.pending,
        createStoreProductAsync.pending,
        getAllStoreProductsAsync.pending,
        getStoreProductByIdAsync.pending,
        updateStoreProductStatusAsync.pending,
        updateStoreProductAsync.pending,
        goalWiseCoursePackagesAsync.pending,
        spokenEnglishPackagesAsync.pending,
        deleteStoreProductAsync.pending,
        updateStoreInventoryAsync.pending,
        decreaseStoreInventoryAsync.pending,
        getAllStoreOrdersAsync.pending,
        storeOrderDetailsAsync.pending,
        updateOrderStatusAsync.pending,
      ),
      (state) => {
        state.storeProductLoader = true;
      },
    );

    builder.addMatcher(
      isAnyOf(spokenEnglishPackagesAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.spokenEnglishPacks = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(goalWiseCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.packageByGoal = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.allPackages = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(createStoreProductAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.createStoreProduct = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getAllStoreProductsAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.getAllStoreProduct = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getStoreProductByIdAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.getStoreProdByIdData = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateStoreProductStatusAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.storePackageStatus = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateStoreProductAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.updateStoreProd = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(deleteStoreProductAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.deleteStorePackage = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateStoreInventoryAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.updateStoreInventory = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(decreaseStoreInventoryAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.decreaseStoreInventory = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getAllStoreOrdersAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.getAllOrders = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(storeOrderDetailsAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.getAllOrderById = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateOrderStatusAsync.fulfilled),
      (state, action) => {
        state.storeProductLoader = false;
        state.updateStatus = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(
        getCoursePackagesAsync.rejected,
        updateStoreProductAsync.rejected,
        updateStoreProductStatusAsync.rejected,
        getStoreProductByIdAsync.rejected,
        createStoreProductAsync.rejected,
        getAllStoreProductsAsync.rejected,
        goalWiseCoursePackagesAsync.rejected,
        spokenEnglishPackagesAsync.rejected,
        deleteStoreProductAsync.rejected,
        updateStoreInventoryAsync.rejected,
        decreaseStoreInventoryAsync.rejected,
        getAllStoreOrdersAsync.rejected,
        storeOrderDetailsAsync.rejected,
        updateOrderStatusAsync.rejected,
      ),
      (state, action) => {
        state.storeProductLoader = false;
      },
    );
  },
  reducers: {
    emptyStorePackage: () => initialState,
  },
});

export const { emptyStorePackage } = storeProductSlice.actions;

export default storeProductSlice.reducer;
